import React from "react";
import { useSearchParams } from "react-router-dom";
import SEO from "@/components/SEO";
import BookingForm from "@/components/BookingForm";

const STEPS = [
  ["01", "Stuur je briefing", "Vertel ons de taal, leeftijd, stemstijl en deadline van je project."],
  ["02", "Wij casten", "Ons gespecialiseerde team selecteert geschikte kinderacteurs uit ons internationale netwerk."],
  ["03", "Beluister & keur goed", "Bekijk voorgestelde stemmen of geef opdracht voor audities op maat."],
  ["04", "Opnemen", "De goedgekeurde stem wordt professioneel geregisseerd en opgenomen."],
  ["05", "Levering", "Productieklare audio wordt geleverd via downloadlink of FTP."],
];

export default function Casting() {
  const [params] = useSearchParams();
  const voice = params.get("voice") || "";
  return (
    <>
      <SEO title="Castingservice — Wij casten voor jou" path="/casting"
        description="Stuur je briefing en wij casten de juiste kinderstemmen voor je productie. Geregisseerde opnames in 30+ talen." />
      <section className="bg-brand-ink text-white">
        <div className="container-x py-14 md:py-16">
          <span className="label-eyebrow text-brand-purple">Castingservice</span>
          <h1 className="mt-2 font-heading text-4xl font-black tracking-tighter md:text-5xl">Wij casten voor jou</h1>
          <p className="mt-3 max-w-2xl text-zinc-300">Weet je niet zeker welk kind het beste past? Stuur ons je briefing en wij stellen de juiste stemmen voor.</p>
        </div>
      </section>

      <section className="container-x section-y">
        <div className="grid gap-5 md:grid-cols-5">
          {STEPS.map(([n, t, d]) => (
            <div key={n} className="rounded-2xl border border-zinc-200 bg-white p-5">
              <span className="font-mono text-sm font-bold text-brand-violet">{n}</span>
              <h3 className="mt-2 font-heading text-lg font-bold">{t}</h3>
              <p className="mt-1 text-sm text-zinc-500">{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-white section-y">
        <div className="container-x max-w-3xl">
          <h2 className="font-heading text-3xl font-bold tracking-tight">Start een boekingsaanvraag</h2>
          <p className="mt-2 mb-8 text-zinc-600">Vertel ons over je project. Dit is nog geen definitieve boeking — we controleren de beschikbaarheid en sturen daarna de prijs en bevestiging.</p>
          <BookingForm initialProjectName={voice} />
        </div>
      </section>
    </>
  );
}
